import React from 'react';
import { HiOutlineInbox } from 'react-icons/hi2';

const EmptyState = ({ icon: Icon = HiOutlineInbox, title, description, action }) => {
  return (
    <div className="empty-state">
      <span className="empty-state-icon">
        <Icon aria-hidden="true" />
      </span>
      <h2>{title}</h2>
      {description && <p>{description}</p>}
      {action}
    </div>
  );
};

export default EmptyState;
